<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        Determine the standard enthalpy of reaction,
        <stemble-latex content="$\Delta\text{H}^\circ_{\text{rxn}},$" />
        for the following reaction using the enthalpies of formation found
        <a
          href="https://cnx.org/contents/RTmuIxzM@9.17:2gdkQpYU@10/Standard-Thermodynamic-Properties-for-Selected-Substances"
          rel="noopener noreferrer"
          target="_blank"
        >
          here.</a
        >
      </p>

      <p class="mb-4 pl-6">
        <chemical-latex content="2 C2H6(g) + 7 O2(g) -> 4 CO2(g) + 6 H2O(l)" />
      </p>

      <calculation-input
        v-model="inputs.reactionEnthalpy"
        prepend-text="$\Delta\text{H}^\circ_{\text{rxn}}:$"
        append-text="$\text{kJ}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import TaskButtons from '../TaskButtons';
import ChemicalLatex from '../displayers/ChemicalLatex';
import CalculationInput from '../inputs/CalculationInput';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question81',
  components: {
    TaskButtons,
    ChemicalLatex,
    CalculationInput,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {
        reactionEnthalpy: null,
      },
    };
  },
};
</script>
